const EXTENSION_IDENTIFIER_WITH_LOG_REGEX = /^([^.]+\..+):(.+)$/;
export { EXTENSION_IDENTIFIER_WITH_LOG_REGEX };
